(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  var button=event.target.closest('[data-card-colour]');
  if(!button)return;
  event.preventDefault();event.stopPropagation();
  var card=button.closest('.card');if(!card)return;
  card.dataset.selectedColour=button.dataset.cardColour;
  card.querySelectorAll('[data-card-colour]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
  var image=card.querySelector('.card__img--primary');
  if(image){
    if(!image.dataset.edtOriginalSrc){image.dataset.edtOriginalSrc=image.getAttribute('src')||'';image.dataset.edtOriginalSrcset=image.getAttribute('srcset')||'';}
    if(button.dataset.colourImage){image.removeAttribute('srcset');image.src=button.dataset.colourImage;card.classList.add('edt-colour-selected');}
    else{image.src=image.dataset.edtOriginalSrc;image.setAttribute('srcset',image.dataset.edtOriginalSrcset);card.classList.remove('edt-colour-selected');}
  }
  card.querySelectorAll('.card__media,.card__title a').forEach(function(link){if(button.dataset.variantUrl)link.href=button.dataset.variantUrl;});
  var qa=card.querySelector('[data-quick-add]');
  if(qa){qa.dataset.selectedColour=button.dataset.cardColour;var select=qa.querySelector('[data-qa-pick]');if(select && Array.from(select.options).some(function(option){return option.value===button.dataset.cardColour;})){select.value=button.dataset.cardColour;select.dispatchEvent(new Event('change',{bubbles:true}));}}
});
  } catch(e) { console.error(e); }
})();

})();
